export default "__VITE_ASSET__CkeAJHqo__"